import { render } from "./App.vue?vue&type=template&id=f54aa61a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=f54aa61a&lang=scss"

import exportComponent from "/Users/peterdevos/Sites/progressive/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__